import request from './request'

import getUrlKey from '@/utils/getUrlKey'
import { serializeParams } from '@/utils/util'
import wx from 'weixin-js-sdk'
import md5 from 'js-md5'
import jsonp from '@/common/js/jsonp'
import {commonParams, options} from './config'

// import {searchCityWeather} from './request'
export const merchantId = getUrlKey(window.location.search).merchantId || 3728  //本地项目调试的时候默认值

export const uid = JSON.parse(sessionStorage.getItem('openIdData') || '{}').id
export const AudioId = getUrlKey(window.location.search).audio_id || 83  //本地项目调试的时候默认值
export const appId = getUrlKey(window.location.search).appid || 'wx20395f51a8f9bca9'

export const client=getUrlKey(window.location.search).client || 'h5'

export const play_id = getUrlKey(window.location.search).play_id
export const prodImg=   window.location.host.includes('www1') ? 'https://f0.xiaoniren.cn': "https://zndl.xiaoniren.cn"
export const is_eng = getUrlKey(window.location.search).is_eng
// export const voteId = getUrlKey(window.location.search).audio_id
export const token = decodeURIComponent( JSON.parse(sessionStorage.getItem('openIdData') || '{}').token) || 'EH2DkIIq6IbWAgO8BsPGXLJ/Rzt+m5sJ09gcS5JVnqm7id8qGt+sCtf7wOxe3C/3+UBUDXLaOflkyW7trOAxyg=='
export const openid = JSON.parse(localStorage.getItem('XnrOpenidMap') || '{}')[merchantId]   // 支付用的openid

export const imgHost = window.location.host.includes('www1') ?  'https://www1.xiaoniren.cn' : 'https://www.xiaoniren.cn'
export const apiHost = window.location.host.includes('www1') ?  'https://www1.xiaoniren.cn' : 'https://www.xiaoniren.cn'
export const baseImgHost = window.location.host.includes('www1') ?  'https://f0.xiaoniren.cn' :  'https://f.xiaoniren.cn'
export const code = getUrlKey(window.location.search).code
export const com_appid = window.location.host.includes('www1') ?  'wx73d729c6d36bf7c7' : 'wx4e2f8c0cd307152d'

export const getOpenid = () => {
  const data = {
    merchant_id: merchantId,
    code,
    operate: 'getOpenid',
    type: 'wechat'
  }

  // const temp = `10029ad96eb8f271a358merchant_id${merchantId}uid${uid|| 0}${new Date().getTime().toString().substr(0, 10)}`
  const temp = `10029ad96eb8f271a358merchant_id${merchantId}uid${JSON.parse(sessionStorage.getItem('openIdData') || '{}').id|| 0}${new Date().getTime().toString().substr(0, 10)}`
  return request({
    url: `/wechat-config`,
    method: 'get',
    params: data,
    headers: {
      data: `{"merchant_id":${merchantId},"uid":${JSON.parse(sessionStorage.getItem('openIdData') || '{}').id || 0}}`,
      ak: '1002',
      time: new Date().getTime().toString().substr(0, 10),
      token,
      sign: md5(temp)
    }
  })
}
export function getAudio (id = '') { // 首页所有参赛用户信息
  return request({
    url: `/voice-spots/${id}`,
    method: 'get',
    params: {
      filter: JSON.stringify([{ explanatio_id: AudioId }]),
      sort: {"id":"asc"},
      page: 1,
      'per-page': 100
    }
  })
}

export function getConfig () { // 首页个人信息
  return request({
    url: `/wechat-config`,
    method: 'get',
    params: {
      operate: 'getJsapiConfig',
      url: window.location.href
    }
  })
}

export function searchTour (params) { // 搜索
  return request({
    url: `/voice-explanatio/search`,
    method: 'get',
    params
  })
}

export function playNum (params) { // 播放次数
  return request({
    url: `/voice-spots/play-num`,
    method: 'get',
    params
  })
}


export function addEvaluate (data) { // 添加景点评价
  return request({
    url: `/voice-evaluate`,
    method: 'post',
    data
  })
}
export function addExplanatio () { // 景区信息提交
  return request({
    url: `/voice-explanatio/${AudioId}`,
    method: 'get'
  })
} 
export function getEvaluate (filter = '', pages = 1) { // 获取景点评价
  return request({
    url: `/voice-evaluate?page=${pages}&per-page=8`,
    method: 'get',
    params: {
      filter: filter
    }
  })
}


export function isBuy (ids) { // 购买状态
  // console.log(sessionStorage.getItem('openidData'))
  return request({
    url: `/voice-order`,
    method: 'get',
    params: {
      filter: JSON.stringify([{'we_openid': openid}, {'explanatio_id': ids}, {'type': 1}])
    }
  })
}

export function toBuy (data) { // 订单生成
  return request({
    url: `/voice-order`,
    method: 'post',
    data
  })
}

export function getOrder () { // 订单生成
  return request({
    url: `/voice-order`,
    method: 'get',
    params: {
      expand: 'user,explanatio',
      filter: JSON.stringify([{'user_id': JSON.parse(sessionStorage.getItem('openIdData') || '{}').id || 0}, {'type': 1}])
    }
  })
}

export function getExplanatios () { // 修改时获取某个景区信息
  return request({
    url: `/voice-explanatio/${AudioId}`,
    method: 'get'
  })
}
// 提交反馈
export function feedback (data) {
   return request({
     url: '/feedback',
     method: 'post',
     data
   })
}

export function searchCityWeatherApi(url, data, options) {
  return jsonp(url, data,options)
}


export function attachment(data){
  return request({
    url:"/attachment",
    method:"post",
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/api.js